<template lang="pug">
  #ReservationIndex.container-width
    h5.text-center.py-3.letter-spacing-6 我要預約
    hr.border-primary.pb-3
    .content.customerInput
      ValidationObserver(
        ref="form"
        tag="form"
        @submit.stop.prevent="submitHandler"
      )
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValStore",
            v-slot="{ errors }"
          )
            multiselect(
              v-model="form.store",
              tag-placeholder="輸入搜尋預約專門店",
              placeholder="請選擇預約專門店",
              selectedLabel="已選擇",
              :showLabels="false",
              selectLabel="",
              label="store_title",
              track-by="store_id",
              :options="reservationStores",
              deselectLabel="",
              :allow-empty="false"
              noOptions="無預約專門店"
            )
              template(slot="noOptions")
                strong 無預約專門店
            div(
              id="input-name-live-feedback",
              v-show="form.store === ''"
            )
              span(
                style="font-size: 80%;color: #dc3545;"
              ) 此欄不可為空
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValService",
            v-slot="{ errors }"
          )
            multiselect(
              v-model="form.service",
              tag-placeholder="輸入搜尋預約服務",
              placeholder="請選擇預約服務",
              selectedLabel="已選擇",
              selectLabel="",
              :showLabels="false",
              label="reserve_type_name",
              track-by="reserve_type_id",
              :options="reservationsTypeList",
              :allow-empty="false",
              deselectLabel="",
              noOptions="無預約服務"
            )
              template(slot="noOptions")
                strong 無預約服務
            div(
              id="input-name-live-feedback",
              v-show="form.service === ''"
            )
              span(
                style="font-size: 80%;color: #dc3545;"
              ) 此欄不可為空
            .pt-2(
              v-if="form.service && form.service.reserve_type_name === '珠寶保養'"
            )
              small.d-block.m-1.text-left 珠寶保養事前須知:
              small.d-block.m-1.text-left 需視實際評估作品後，可能有部分收費需求或更長工作天進行後續服務。
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValDate"
          )
            b-form-datepicker.d-flex.align-items-center.justify-content-center.date-custom(
              id="date",
              type="date",
              required,
              trim,
              :state="validState('date')",
              v-model="form.date",
              aria-describedby="input-live-help input-name-live-feedback",
              placeholder="請選擇希望來店日期",
              :min="dateMinLimit",
              :max="dateMaxLimit",
              @input="getReservationTimeHandler()"
            )
            b-form-invalid-feedback(
              id="input-name-live-feedback"
            )
              span 此欄不可為空
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValTimeId"
          )
            multiselect.padding-right-0(
              v-model="form.timeId",
              :showLabels="false",
              tag-placeholder="輸入搜尋預約時段",
              placeholder="請選擇希望預約時段",
              selectedLabel="已選擇",
              selectLabel="",
              label="start_time",
              track-by="reserve_period_id",
              :custom-label="nameWithTimeId",
              :options="reservationTimeList",
              :allow-empty="false",
              noOptions="無預約時段",
              style="height: 45px;"
            )
              template(slot="noOptions")
                strong 無可預約時段
            div(
              id="input-name-live-feedback",
              v-show="form.timeId === ''"
            )
              span(
                style="font-size: 80%;color: #dc3545;"
              ) 此欄不可為空
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValName"
          )
            b-form-input(
              id="lastName",
              type="text",
              required,
              trim,
              :state="validState('last_name')",
              v-model="form.last_name",
              aria-describedby="input-live-help input-name-live-feedback",
              placeholder="出席貴賓姓",
              class="rounded-0 bg-light border-black text-center"
            )
            b-form-invalid-feedback(
              id="input-name-live-feedback"
            )
              span 此欄不可為空
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValName"
          )
            b-form-input(
              id="firstName",
              type="text",
              required,
              trim,
              :state="validState('first_name')",
              v-model="form.first_name",
              aria-describedby="input-live-help input-name-live-feedback",
              placeholder="出席貴賓名",
              class="rounded-0 bg-light border-black text-center"
            )
            b-form-invalid-feedback(
              id="input-name-live-feedback"
            )
              span 此欄不可為空
        b-form-group
          ValidationProvider(
            rules="required|mobile",
            ref="inputValMobile",
            v-slot="{ errors }"
          )
            b-form-input(
              id="mobile",
              type="tel",
              required,
              trim,
              :state="validState('mobile')",
              v-model="form.mobile",
              aria-describedby="input-live-help input-name-live-feedback",
              placeholder="請輸入行動電話"
            )
            b-form-invalid-feedback(
              id="input-name-live-feedback"
            )
              span {{ errors[0] }}
        b-form-group
          ValidationProvider(
            rules="required",
            ref="inputValJoinPeople",
            v-slot="{ errors }"
          )
            multiselect(
              v-model="form.joinPeople",
              tag-placeholder="輸入搜尋參與人數",
              placeholder="請選擇參與人數",
              selectedLabel="已選擇",
              selectLabel="",
              :showLabels="false",
              label="text",
              track-by="id",
              deselectLabel="",
              :options="joinPeopleOption",
              :allow-empty="false"
              noOptions="無參與人數"
            )
              template(slot="noOptions")
                strong 無參與人數
            div(
              id="input-name-live-feedback",
              v-show="form.joinPeople === ''"
            )
              span(
                style="font-size: 80%;color: #dc3545;"
              ) 此欄不可為空
              span 此欄不可為空
        b-form-group
          b-form-textarea(
            id="m_note",
            type="text",
            rows="3",
            v-model="form.m_note",
            placeholder="輸入備註",
          )
      .row.no-gutters
        .col-12
          button.btn.btn-block.btn-primary.text-center.rounded-0(
            type="button",
            @click="submitHandler()"
          ) 送出
</template>

<script>
import { mapState } from 'vuex';
import { UN_M_RESERVATION_SUCCESS } from '@/router/unbindMember/reservation';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import $ from 'jquery';
// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

// 客製化手機驗證
extend('mobile', {
  validate: (val) => {
    const MobileReg = /^(09)[0-9]{8}$/;
    return MobileReg.test(val);
  },
  message: '行動電話格式錯誤'
});

const moment = require('moment');
const _ = require('lodash');

export default {
  name: 'ReservationCreate',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      form: {
        store: null,
        service: null,
        date: null,
        timeId: null,
        first_name: null,
        last_name: null,
        mobile: null,
        joinPeople: null,
        m_note: null
      },
      joinPeopleOption: [
        {
          id: 1, text: '1'
        },
        {
          id: 2, text: '2'
        }
      ],
      dateMinLimit: moment().add(3, 'days').format(),
      dateMaxLimit: moment().add(33, 'days').format()
    };
  },
  created() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    vm.$swal.fire({
      title: '請稍候，\n載入中',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.dispatch('un_member_reservation/getReservationStoresHandler')
      .then(() => {
        vm.$store.dispatch('un_member_reservation/getCustomerReservationTypesHandler')
          .then(() => {
            vm.$swal.close();
          });
      });
  },
  methods: {
    moment() {
      return moment();
    },
    nameWithTimeId({ start_time, end_time }) {
      return `${start_time}~${end_time}`;
    },
    getReservationTimeHandler() {
      const vm = this;
      if (vm.form.store && vm.form.date) {
        vm.$swal.fire({
          title: '請稍候，\n取得該店可預約時段中',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });
        vm.$store.dispatch('un_member_reservation/getReservationTimeListHandler', {
          store_id: vm.form.store.store_id,
          reserve_date: vm.form.date
        })
          .then((data) => {
            if (data.options.length === 0) {
              vm.form.timeId = '';
              vm.$swal.fire({
                icon: 'info',
                title: '請選擇其他預約日期、此日期無預約時段'
              }).then(() => {
                $('#date').click();
              });
            } else {
              vm.$swal.close();
            }
          });
      } else {
        vm.$store.commit('un_member_reservation/resetReservationTimeListHandler');
        vm.form.timeId = null;
      }
    },
    // 檢查欄位
    validState(key) {
      const vm = this;
      // 其餘統一判斷
      if (vm.form[key] !== null) {
        return this.form[key] ? true : false;
      }
      return null;
    },
    // 送出表單
    async submitHandler() {
      const vm = this;
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        if (vm.form.store === null) {
          vm.form.store = '';
        }
        if (vm.form.service === null) {
          vm.form.service = '';
        }
        if (vm.form.date === null) {
          vm.form.date = '';
        }
        if (vm.form.timeId === null) {
          vm.form.timeId = '';
        }
        if (vm.form.first_name === null) {
          vm.form.first_name = '';
        }
        if (vm.form.last_name === null) {
          vm.form.last_name = '';
        }
        if (vm.form.mobile === null) {
          vm.form.mobile = '';
        }
        if (vm.form.joinPeople === null) {
          vm.form.joinPeople = '';
        }
        vm.$swal.fire({
          icon: 'error',
          title: '請填妥必填欄位或格式輸入錯誤'
        });
      } else {
        const key = _.findKey(vm.reservationTimeList, (val) => val.id === vm.form.timeId.id);
              const now = moment().format('hh:mm');
              const beginTime = moment(vm.reservationTimeList[key].start_time, 'hh:mma');
              const endTime = moment(now, 'hh:mma');
              const today = moment().format('YYYY-MM-DD');
              const reservationDate = moment(vm.form.date).format('YYYY-MM-DD');

        if (moment(reservationDate).isBefore(today)) {
          vm.$swal.fire({
            icon: 'error',
            title: '預約時間不可小於目前日期'
          });
        } else if (vm.form.date === moment().format('YYYY-MM-DD') && beginTime.isBefore(endTime)) {
          vm.$swal.fire({
            icon: 'error',
            title: '預約時間不可小於目前時間'
          });
        } else {
          vm.$swal.fire({
            title: '請稍候，\n表單送出中',
            allowOutsideClick: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });

          const sendData = {
            store_id: vm.form.store.store_id,
            reservation_type_id: vm.form.service.reserve_type_id,
            reservation_period_id: vm.form.timeId.reserve_period_id,
            reservation_date: vm.form.date,
            first_name: vm.form.first_name,
            last_name: vm.form.last_name,
            mobile: vm.form.mobile,
            companion: vm.form.joinPeople.id,
            m_note: vm.form.m_note
          };

          vm.$store.dispatch('un_member_reservation/storeReservationHandler', sendData)
            .then(() => {
              vm.$swal.close();
              vm.$router.push({
                name: UN_M_RESERVATION_SUCCESS
              });
            });
        }
      }
    }
  },
  computed: {
    ...mapState({
      reservationStores: (state) => state.un_member_reservation.reservationStores,
      reservationsTypeList: (state) => state.un_member_reservation.reservationsTypeList,
      reservationTimeList: (state) => state.un_member_reservation.reservationTimeList
    })
  }
};
</script>

<style lang="scss" scoped>
.customerInput {
  * {
    text-align: center;
  }
  input,
  select,
  .b-form-btn-label-control,
  .itemRow {
    border-radius: 0;
    border: 0;
    border-top: 1px solid #e8e8e8!important;
    border-bottom: 1px solid #e8e8e8!important;
    background-color: #FCFBFB;
    text-align: center;
    text-align-last: center;
    height: 45px;
    padding-right: 0;
    span {
      width: 100%;
    }
  }
}
</style>
<style>
  .multiselect__tags {
    padding-right: 0!important;
  }
  .date-custom label{
    margin-left: -1.25rem!important;
  }
</style>
